import React, { Component } from 'react';
import ReactJson from 'react-json-view';

export class ProxiedReactJson extends Component {
    componentDidMount() {
        const selector = '.edit-check.detected';

        // eslint-disable-next-line no-undef
        this.observer = new MutationObserver(() => {
            if (document.querySelector(selector)) {
                [...document.querySelectorAll(selector)]
                    .forEach(el => el.parentElement.parentElement.removeChild(el.parentElement));
            }
        });

        this.observer.observe(document.body, {
            childList: true,
            subtree: true,
        });
    }
    componentWillUnmount() {
        this.observer.disconnect();
    }
    render() {
        return (
            <div>
                <ReactJson {...this.props} />
            </div>
        );
    }
}



/** WEBPACK FOOTER **
 ** ./src/components/ProxiedReactJson.js
 **/